export type BasicTagInfo = {
  tagFQN: string;
  name: string;
  displayName: string;
};

type TagLike = {
  tagFQN: string;
  name: string;
  displayName?: string;
};

export const mapTagToBasicInfo = (tag: TagLike): BasicTagInfo => {
  const fallbackName = tag.tagFQN.split('.').pop() || tag.tagFQN;

  return {
    tagFQN: tag.tagFQN,
    name: tag.name,
    displayName: tag.displayName || tag.name || fallbackName,
  };
};

export const mapTagsToBasicInfo = (tags: TagLike[]): BasicTagInfo[] => {
  return tags.map(mapTagToBasicInfo);
};
